import { render } from "./ResponsibleGamblingCheckModal.vue?vue&type=template&id=50a90e92&scoped=true"
import script from "./ResponsibleGamblingCheckModal.vue?vue&type=script&lang=js"
export * from "./ResponsibleGamblingCheckModal.vue?vue&type=script&lang=js"

import "./ResponsibleGamblingCheckModal.vue?vue&type=style&index=0&id=50a90e92&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a90e92"]])

export default __exports__